/* unplugin-vue-components disabled */import { render } from "./particleList.vue?vue&type=template&id=22dec416&scoped=true"
import script from "./particleList.vue?vue&type=script&lang=js"
export * from "./particleList.vue?vue&type=script&lang=js"

import "./particleList.vue?vue&type=style&index=0&id=22dec416&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-22dec416"]])

export default __exports__